
export default {
  name: "SvgNpostart",
}
